var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 105H30C23.3825 105 18 99.6175 18 93V27C18 20.3825 23.3825 15 30 15H90C96.6175 15 102 20.3825 102 27V93C102 99.6175 96.6175 105 90 105ZM30 21C26.6925 21 24 23.6925 24 27V93C24 96.3075 26.6925 99 30 99H90C93.3075 99 96 96.3075 96 93V27C96 23.6925 93.3075 21 90 21H30Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7875 49.46C80.7875 52.305 80.1025 54.9725 78.73 57.46C77.41 59.95 75.3 61.955 72.405 63.48C69.56 65.005 65.9525 65.765 61.585 65.765H52.67V86.1875H42.0025V32.9975H61.5875C65.7025 32.9975 69.2075 33.7075 72.1025 35.13C74.9975 36.5525 77.1575 38.5075 78.58 40.9975C80.0525 43.4875 80.79 46.3075 80.79 49.455L80.7875 49.46ZM61.1275 57.1575C64.075 57.1575 66.2575 56.4975 67.68 55.175C69.1025 53.8025 69.8125 51.8975 69.8125 49.46C69.8125 44.2775 66.9175 41.6875 61.125 41.6875H52.6675V57.1575H61.1275Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.0b05a9f8.svg";
export { ForwardRef as ReactComponent };